<template>
  <div>
    <breadcrumb/>
    <post-list category="Factoring-Noticias y Blog de Actualidad - Informacion ACHEF Mensual"></post-list>
  </div>
</template>

<script>
import PostList from "@/components/Posts/PostList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    PostList,
    Breadcrumb
  }
};
</script>